import React  from "react";
import { Form, Col } from "react-bootstrap";


export default function SectionHeader({strSectionHeader}) {

    return (
        <>
        <Form.Row>
          <Col xs={12}>
            <Form.Group as={Col} className="border-bottom border-dark mt-4 mb-4" >
              <Form.Label className="section-header">{strSectionHeader}</Form.Label>
            </Form.Group>
          </Col>  
        </Form.Row>
        </>);
}

